/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

function plural(val: number): number {
const n = val;

if (n === 1)
    return 1;
return 5;
}

export default ["brx",[["फुं","बेलासे"]],u,[["र","स","मं","बु","बि","सु","सु"],["रबि","सम","मंगल","बुध","बिस्थि","सुखुर","सुनि"],["रबिबार","समबार","मंगलबार","बुधबार","बिस्थिबार","सुखुरबार","सुनिबार"],["रबि","सम","मंगल","बुध","बिस्थि","सुखुर","सुनि"]],u,[["ज","फ","म","ए","म","ज","ज","आ","स","अ","न","ड"],["जान","फेब","मार्च","एप्रि","मे","जुन","जुल","आग","सेप","अक्ट’","नवे","डिसे"],["जानुवारी","फेब्रूवारी","मार्च","एप्रिल","मे","जुन","जुलाई","आगष्ट","सेप्थेम्बर","अक्ट’बर","नवेम्बर","डिसेम्बर"]],u,[["बि.सि.","ए.दि"]],0,[0,0],["y-MM-dd","MMM d, y","MMMM d, y","y MMMM d, EEEE"],["a नि h:mm","a h:mm:ss","a h:mm:ss z","a h:mm:ss zzzz"],["{1}, {0}",u,"{1} नि {0} याव",u],[".",",",";","%","+","-","E","×","‰","∞","NaN",":"],["#,##,##0.###","#,##,##0%","¤ #,##,##0.00","#E0"],"INR","₹","भारतनि रुपी",{"CNY":["सिएन¥","¥"],"JPY":["JP¥","¥"],"RUB":["रूब","₽"]},"ltr", plural];
